// extracted by css-extract-rspack-plugin
export default {"menuAnchorButton":"menu-anchor-module__menuAnchorButton__EuoXD"};